import React, { Component, Fragment } from 'react';
import classNames from 'classnames';

import Button from 'components/Button';
import Icon, { ICON_NAMES } from 'components/Icon';
import ProfileMenuList from './ProfileMenuList';


class MobileProfileMenu extends Component {

  render() {
    const { onClose, isMenuOpen, role } = this.props;

    return (
      <Fragment>
        <div
          className={classNames("main-menu-oerlay", {
            "main-menu-oerlay--open": isMenuOpen,
          })}
          onClick={onClose}></div>
        <div
          className={classNames("mobile-menu-container mobile-menu-container--profile", {
            "open": isMenuOpen,
          })}>
          <Button
            bgColor={null}
            className="close-btn profile-menu__close-btn"
            onClick={onClose}>
            <Icon name={ICON_NAMES.closeCircle} className="btn-icon icon-close" />
          </Button>
          <div className="mobile-menu-wrapper">
            <div className="mobile-menu-inner">
              <ProfileMenuList role={role} onClickOutside={onClose} />
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default MobileProfileMenu;